(() => {
  const resizeSliderContentOnMobile = (slider, adjustPrevNext) => {
    // create hidden slider duplicate with all slides visible to be able to measure the height of the slides
    const sliderHTML = slider.outerHTML;
    const windowWidth = window.innerWidth

    // required for the right size outside the viewport #}
    const predictor = document.createElement('div')
    predictor.id = 'mobile_slider_height_predictor'
    predictor.style.cssText = 'position:absolute; top:-10000px; left:-10000px; width: ' + windowWidth + 'px;'
    predictor.innerHTML = '<div class="container">' + sliderHTML + '</div>'
    document.body.appendChild(predictor)

    predictor.querySelectorAll('.carousel-item').forEach(function (element) {
      element.classList.add('active')
    })

    // all images have to be loaded to get correct height values
    imagesLoaded(predictor, () => {
      let highestBox = 0;
      predictor.querySelectorAll('.col_text').forEach((slide) => {
        slide.style.height = 'auto'; // reset height if height was set in previous run (onresize in desktop mode)

        const currentHeight = slide.outerHeight;
        if (currentHeight && currentHeight > highestBox) {
          highestBox = currentHeight;
        }
      });

      predictor.remove();

      // adjust height of textbox in the real slider, to prevent indicator jumping
      slider.querySelectorAll('.col_text').forEach(function (element) {
        element.style.height =  `${highestBox}px`
      })

      if (adjustPrevNext) {
        const imgHeight = slider.querySelector('.active .mobile_image').height

        slider.querySelectorAll('.carousel-control-prev').forEach(function (element) {
          element.style.height =  `${imgHeight}px`
        })

        slider.querySelectorAll('.carousel-control-next').forEach(function (element) {
          element.style.height =  `${imgHeight}px`
        })
      }
    })
      .catch(console.error);
  }

  const resizeSliderContentNonMobile = (slider, adjustPrevNext) => {
    slider.querySelectorAll('.col_text').forEach(function (element) {
      element.style.height = 'auto'
    })

    if (adjustPrevNext) {
      slider.querySelectorAll('.carousel-control-prev').forEach(function (element) {
        element.style.height = 'auto'
      })

      slider.querySelectorAll('.carousel-control-next').forEach(function (element) {
        element.style.height = 'auto'
      })
    }
  }

  const resizeMobileSliderContent = (slider, adjustPrevNext ) => {
    const windowWidth = window.innerWidth

    if (windowWidth && windowWidth < 768) {
      resizeSliderContentOnMobile(slider, adjustPrevNext);
    } else {
      resizeSliderContentNonMobile(slider, adjustPrevNext);
    }
  }

  const updateAriaHidden = (slider) => {
    let items = slider.querySelectorAll('.carousel-item');
    items.forEach(function(item) {
      if (item.classList.contains('active')) {
        item.setAttribute('aria-hidden', 'false');
      } else {
        item.setAttribute('aria-hidden', 'true');
      }
    });
  }

  const updateLiveRegion = (slider) => {
    let items = slider.querySelectorAll('.carousel-indicators li');
    let activeSlideIndex = Array.from(items).indexOf(slider.querySelector('.carousel-indicators li.active')) + 1;
    let totalSlides = items.length;
    slider.querySelector('.liveregion').textContent = 'Eintrag ' + activeSlideIndex + ' von ' + totalSlides;
  }

  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.ce_carousel').forEach((slider) => {

      let interval = slider.getAttribute('data-interval');
      if (!interval) {
        interval = false;
      }

      const carouselOption = {
        interval,
        keyboard: true,
        pause: 'hover',
        wrap: true,
      };

      new BSN.Carousel(slider, carouselOption)

      // We only wanted to change the slide interval (above).
      // But as a "feature" we have to re enable the other carousel behavior as well...
      slider.addEventListener('click', (e) => {
        window.setTimeout(() => updateAriaHidden(slider), 1000);
        window.setTimeout(() => updateLiveRegion(slider), 500);

        if (!e.currentTarget.matches("button.carousel-control-prev,button.carousel-control-next")) {
          return
        }

        e.preventDefault();
        e.stopPropagation();

        let offset = (e.currentTarget.getAttribute('data-slide') === 'next') ? +1 : -1

        slider.Carousel.slideTo(slider.Carousel.getActiveIndex() + offset)



      })

      slider.addEventListener('click', (e) => {
        if (!e.currentTarget.matches("button[data-slide-to]")) {
          return
        }

        e.preventDefault();
        e.stopPropagation();

        slider.Carousel.slideTo(e.currentTarget.getAttribute('data-slide-to'))

      })

      slider.querySelectorAll('.carousel-control-prev, .carousel-control-next').forEach(function (element) {
       element.addEventListener('keyup', (e) => {
         if (e.keyCode !== 13) {
           return
         }

         element.click()
       })
      })

      if (slider.classList.contains('adjust_mobile_height')) {
        slider.addEventListener('slide.bs.carousel', event => {
          resizeMobileSliderContent(slider, slider.classList.contains('adjust_mobile_prev_next_height'));
        });

        window.addEventListener('resize', () => {
          resizeMobileSliderContent(slider, slider.classList.contains('adjust_mobile_prev_next_height'));
        })

        window.dispatchEvent(new Event('resize'));
      }

      Array.from(slider.querySelectorAll('.image-stage'))
        .slice(1)
        .forEach(imageStage => {
          if (imageStage.style.backgroundImage && imageStage.style.backgroundImage.startsWith('url')) {
            new Image().src = imageStage.style.backgroundImage.replace(/url|\(|\)|'|"/gi, '');
          }
        })
    });
  })
}) ()

